import { render, staticRenderFns } from "./ResetMetodeVerifikasiView.vue?vue&type=template&id=380dc648&scoped=true"
import script from "./ResetMetodeVerifikasiView.vue?vue&type=script&lang=js"
export * from "./ResetMetodeVerifikasiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380dc648",
  null
  
)

export default component.exports